import React, {useMemo} from "react";
import PreFooter from "@components/Prefooter/PreFooter";
import PageHeader from "@components/Page/PageHeader";
import {findFirstSection, getCmsPage} from "@lib/Cms/CmsUtils";
import {SECTION_TYPE} from "@lib/Cms/CmsModels";
import Page from "@components/Page/Page";
import PageContent from "@components/Page/PageContent";
import PageSection from "@components/Page/PageSection";
import CatalogPreview from "@components/Catalog/CatalogPreview/CatalogPreview";
import BoostCard from "@components/Boost/BoostCard/BoostCard";
import BoostImage from "@assets/images/tmp/boost.png";
import {buildRoute} from "@router/RouterUtils";
import {AppRoute} from "@router/RoutingModels";
import "./BoostsPage.scss";

export default function BoostsPage() {

    const {sections, ...page} = useMemo(() => getCmsPage("events") ?? {}, []);

    const defaultSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.DEFAULT), [sections]);
    const catalogSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.CATALOG_PREVIEW), [sections]);
    const preFooterSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.PRE_FOOTER), [sections]);

    return (
        <>
            <Page>

                <PageHeader cms={page}/>

                <PageContent>

                    <PageSection bg={defaultSection?.options?.bgType}>

                        <div className="boost-list">
                            <section className="boost-list__grid" aria-label="Boost list">
                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Interactive"}
                                    title={"Complete the survey"}
                                    date={"15 - 31 January 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 1})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Educational"}
                                    title={"Watch the video"}
                                    date={"12 - 14 June 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 2})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Special Purchase"}
                                    title={"Buy new equipment"}
                                    date={"15 March 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 3})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Category"}
                                    title={"Boost number four"}
                                    date={"15 - 16 March 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 4})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Category"}
                                    title={"Boost number five"}
                                    date={"15 - 16 March 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 5})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Interactive"}
                                    title={"Complete the survey"}
                                    date={"15 - 31 January 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 1})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Educational"}
                                    title={"Watch the video"}
                                    date={"12 - 14 June 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 2})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Special Purchase"}
                                    title={"Buy new equipment"}
                                    date={"15 March 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 3})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Category"}
                                    title={"Boost number four"}
                                    date={"15 - 16 March 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 4})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Category"}
                                    title={"Boost number five"}
                                    date={"15 - 16 March 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 5})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Interactive"}
                                    title={"Complete the survey"}
                                    date={"15 - 31 January 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 1})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Educational"}
                                    title={"Watch the video"}
                                    date={"12 - 14 June 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 2})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Special Purchase"}
                                    title={"Buy new equipment"}
                                    date={"15 March 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 3})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Category"}
                                    title={"Boost number four"}
                                    date={"15 - 16 March 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 4})}}
                                />

                                <BoostCard
                                    image={BoostImage}
                                    categoryName={"Category"}
                                    title={"Boost number five"}
                                    date={"15 - 16 March 2026"}
                                    linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 5})}}
                                />
                            </section>
                        </div>

                    </PageSection>

                    {!!catalogSection && <CatalogPreview cms={catalogSection}/>}

                </PageContent>

            </Page>

            {!!preFooterSection && <PreFooter cms={preFooterSection}/>}

        </>
    );
}
